import magnifiAPIInstance from "./apiInstance";

export const entityConfigAPIs = {
  getEntityConfig: ({ entityId, payload }) => magnifiAPIInstance.get(`/get-client-settings/${entityId}`, payload),
  updateClientSetting: ({ payload }) => magnifiAPIInstance.post("/client-settings", payload),
  createCustomField: ({ entityId, payload }) => magnifiAPIInstance.put(`/setting_fields/${entityId}`, payload),
  updateCustomField: ({ entityId, payload }) => magnifiAPIInstance.post(`/update-setting/${entityId}`, payload),
  deleteCustomField: ({ payload }) => magnifiAPIInstance.post(`/delete/custom_fields`, payload),
};
